import { API } from 'aws-amplify'
import { requiresInsurance, getProductFrom, useDailyInsurance, getSkuPrice } from './utils'
import discountedItems from './discountedItems'
import Products from './products'

export const insuranceMandatoryPrice = (item, skus) =>
  useDailyInsurance(item.passType)
    ? 0
    : getSkuPrice('insurance', 'mandatoryYearlySkuId', skus)

export const totalOrderSum = (items, skus, discountCode) => {
  if (items.length === 0) return 0

  return items.map(item => {
    const skuToUse = item.skuToUse || 'giftcardSkuId'
    let price = getSkuPrice(item.passType, skuToUse, skus)
    // if (skuToUse !== 'giftcardSkuId') {
    //   // Insurance is included in the giftcard price because some giftcards might be used for other products than originally intended
    //   // - hence not include as product when buying giftcard
    //   price += insuranceMandatoryPrice(item, skus)
    // }

    return discountedItems(discountCode).length !== 0
      ? price - discountedItems(discountCode).find(d => d.id === item.passType).cashOff
      : price
  }).reduce((total, num) => total + num)
}

export const totalOrderDiscount = (couponInfo, items, skus) => couponInfo
  ? this.totalOrderSum(items, skus) * couponInfo.percent_off / 100
  : 0

export const totalOrderPrice = (items, skus, discountCode, couponInfo) => 
  totalOrderSum(items, skus, discountCode) - totalOrderDiscount(couponInfo, items, skus)

const unique = items => items.reduce((existing, item) => {
  const alreadyAddedIndex = existing.findIndex(u => u.passType === item.passType)
  if (alreadyAddedIndex !== -1) {
    const existingCopy = [...existing]
    existingCopy[alreadyAddedIndex].quantity += 1
    return existingCopy
  }
  return [...existing, { ...item, quantity: 1 }]
}, [])

const shouldAddInsurance = item => requiresInsurance(item.passType) && !useDailyInsurance(item.passType)

const itemsI18nNames = (items, intl) => unique(items).map(item => {
    const product = Products.find(p => p.id === item.passType)
    return intl.formatMessage({ id: `passTypes.${product.id}` })
      .concat(product.type === 'pass' ? `, ${intl.formatMessage({ id: `giftcards.${product.ageCategory}` })}` : '')
}).join(';')

// const itemsI18nAmounts = (items, intl, skus) => unique(items).map(item => {
//   const skuToUse = item.skuToUse || 'giftcardSkuId'

//   return [
//     getSkuPrice(item.passType, skuToUse, skus),
//     (shouldAddInsurance(item) && getSkuPrice('insurance', 'mandatoryYearlySkuId', skus))
//   ].map(price => `${intl.formatNumber(price * item.quantity, { minimumFractionDigits: 2 })} kr.`).join(';')
// }).join(';')

const discounts = (items, couponInfo, skus) => items.map(item => {
  if (couponInfo) {
    const skuToUse = item.skuToUse || 'giftcardSkuId'
    const price = getSkuPrice(item.passType, skuToUse, skus)
    return (price * couponInfo.percent_off) / 100
  }

  const discountedItem = discountedItems().find(d => d.id === item.passType)
  return discountedItem ? discountedItem.cashOff : ''
}).join(';')

export const stripeOrderCreateWithPayment = async (items, email, couponInfo, intl, skus, discountCode) => {

  const stripeItems = []

  items.forEach(item => {
    const product = Products.find(p => p.id === item.passType)

    // Aggregate skus
    const skuToUse = item.skuToUse || 'giftcardSkuId'
    const passItem = stripeItems.find(i => i.parent === product[skuToUse])
    if (passItem) {
      passItem.quantity += 1
    } else {
      stripeItems.push({ parent: product[skuToUse], quantity: 1 })
    }

    // if (shouldAddInsurance(item) && skuToUse !== 'giftcardSkuId') {
    //   const insuranceProduct = getProductFrom('insurance')
    //   const insuranceItem = stripeItems.find(i => i.parent === insuranceProduct.mandatoryYearlySkuId)
    //   if (insuranceItem) {
    //     insuranceItem.quantity += 1
    //   } else {
    //     stripeItems.push({ parent: insuranceProduct.mandatoryYearlySkuId, quantity: 1 })
    //   }
    // } 

    const discountedItem = discountedItems().find(d => d.id === product.id)
    if (discountedItem) {
      const discountedStripeItem = stripeItems.find(i => i.parent === product[skuToUse] && i.type === 'discount')

      if (discountedStripeItem) {
        discountedStripeItem.quantity += 1
      } else {
        stripeItems.push({
          parent: product[skuToUse],
          quantity: 1,
          type: 'discount',
          amount: (discountedItem.cashOff * -100),
          currency: discountedItem.currency,
          description: `Discount code: ${discountCode}`
        })
      }
    }
  })

  // Create Stripe order
  const orderParameters = {
    body: {
      endpoint: 'orders.create',
      parameters: {
        currency: 'dkk',
        items: stripeItems,
        email,
        metadata: {
          itemsI18nNames: itemsI18nNames(items, intl),
          // itemsI18nAmounts: itemsI18nAmounts(items, intl, skus),
          // orderI18nAmount: `${intl.formatNumber(totalOrderPrice(items, skus), { minimumFractionDigits: 2 })} kr.`,
          // orderI18nVAT: `${intl.formatNumber(totalOrderPrice(items, skus) / 5.0, { minimumFractionDigits: 2 })} kr.`,
          discounts: discounts(items, couponInfo, skus),
          lang: intl.locale,
          renewMembershipIds: items.map(item => item.membershipId).join(';')
        }
      } // ,
      // options: {
      //   idempotency_key: idempotencyKey
      // }
    }
  }
  if (couponInfo) {
    orderParameters.body.parameters = {
      ...orderParameters.body.parameters,
      coupon: discountCode
    }
  }
  const order = await API.post('cphill', "/stripe/proxy", orderParameters)
  return order
}    

const StandalonePurchase = {
  totalOrderSum,
  totalOrderDiscount,
  totalOrderPrice,
  stripeOrderCreateWithPayment
}
  
export default StandalonePurchase